import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from './api';

export interface DemoStatus {
  demoCount: number;
  realEmployeeCount: number;
  loaded: boolean;
}

/** Owner/admin only — 403 otherwise, so callers should gate by role. */
export function useDemoStatus(enabled = true) {
  return useQuery({
    queryKey: ['demo', 'status'],
    queryFn: async () => (await api.get<DemoStatus>('/api/demo/status')).data,
    enabled,
    retry: false,
  });
}

export function useSeedDemo() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (force?: boolean) => (await api.post<{ seeded: number; complianceCreated: number }>('/api/demo/seed', { force })).data,
    onSuccess: () => qc.invalidateQueries(),
  });
}

export function useClearDemo() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async () => (await api.post<{ removed: number }>('/api/demo/clear', {})).data,
    onSuccess: () => qc.invalidateQueries(),
  });
}
